"use client"

import Image from "next/image"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { RiHome4Line, RiRefreshLine } from "react-icons/ri"

import { Button } from "@/components/Button"
import { useLocaleConfig } from "@/providers/localeConfig"
import { useLocaleStrings } from "@/providers/localeStrings/client"

import { ErrorBox, ErrorCard, Footer, H2, Paragraph } from "./styled"

const imageStyle = {
  borderRadius: "0.375rem",
  marginBottom: "1rem",
}

const handleReload = () => {
  location.reload()
}
export const ErrorPage = ({ title }) => {
  const locale = useLocaleConfig().locale ?? "de-DE"

  const {
    ERROR_PAGE_MESSAGE,
    ERROR_PAGE_SUPPORT_US_1,
    ERROR_PAGE_SUPPORT_US_2,
    ERROR_PAGE_SUPPORT_MAIL,
    ERROR_PAGE_HOME,
    ERROR_PAGE_RELOAD,
  } = useLocaleStrings()
  return (
    <ErrorBox>
      <ErrorCard>
        <H2>{title}</H2>

        <Image
          className="rounded"
          src="/images/error.jpeg"
          style={imageStyle}
          alt="Farbe ausgelaufen"
          width={356}
          height={200}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          quality={100}
        />

        <Paragraph>{ERROR_PAGE_MESSAGE}</Paragraph>
        <br />
        <Paragraph>
          {ERROR_PAGE_SUPPORT_US_1}
          &nbsp;
          <Link href={`mailto:${ERROR_PAGE_SUPPORT_MAIL}`}>{ERROR_PAGE_SUPPORT_MAIL}</Link>
          &nbsp;
          {ERROR_PAGE_SUPPORT_US_2}
        </Paragraph>

        <Footer>
          <Button rounded secondary href={`/${locale}`} submit>
            <RiHome4Line size="1.5rem" />
            {ERROR_PAGE_HOME}
          </Button>

          <Button rounded seo handleClick={() => handleReload()}>
            <RiRefreshLine size="1.5rem" />
            {ERROR_PAGE_RELOAD}
          </Button>
        </Footer>
      </ErrorCard>
    </ErrorBox>
  )
}
